import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { getInitials } from "@/lib/utils";
import React from "react";

type LocationShorthandPillProps = {
  location: string;
  /** Explicit short code (e.g. the location's stored `initials`). Falls back to initials of `location`. */
  shortCode?: string;
  tooltipText?: string;
  className?: string;
};

const LocationShorthandPill: React.FC<LocationShorthandPillProps> = ({ location, shortCode, tooltipText, className = "" }) => {
  const initials = shortCode?.trim() || getInitials(location);
  return (
    <span
      className={`inline-block px-2 py-0.5 rounded-full bg-gray-200 text-xs font-semibold text-gray-700 ${className}`}
      title={location}
    >
      <Tooltip delayDuration={0}>
        <TooltipTrigger>
          <span className="cursor-pointer" role="button" tabIndex={0} aria-label={`Location: ${location}`}>
            {initials}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltipText || location}</p>
        </TooltipContent>
      </Tooltip>
    </span>
  );
};

export default LocationShorthandPill;
